import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'

class ClickListener extends Component {
  constructor (props) {
    super(props)

    this.wrapperRef = createRef()
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount () {
    this.wrapperRef.current.getRootNode().addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount () {
    this.wrapperRef.current.getRootNode().removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside (event) {
    if (this.wrapperRef && !this.wrapperRef.current?.contains(event.target)) {
      this.props.trigger()
    }
  }

  render () {
    return <div className={this.props.className} ref={this.wrapperRef}>{this.props.children}</div>
  }
}

ClickListener.propTypes = {
  children: PropTypes.element.isRequired,
  trigger: PropTypes.func.isRequired
}

export default ClickListener
